import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

export interface EnterpriseAccess {
  hasLicense: boolean;
  orgActive: boolean;
  /** Licencia asignada y contrato de la empresa vigente */
  grantsAccess: boolean;
  /** Tiene licencia pero el contrato de la empresa no está vigente */
  isExpired: boolean;
  contractEndDate: string | null;
}

export async function fetchEnterpriseAccess(): Promise<EnterpriseAccess> {
  const { data } = await (supabase.rpc as any)('my_enterprise_access');
  const row = Array.isArray(data) ? data[0] : data;
  const hasLicense = !!row?.has_license;
  const orgActive = !!row?.org_active;
  return {
    hasLicense,
    orgActive,
    grantsAccess: hasLicense && orgActive,
    isExpired: hasLicense && !orgActive,
    contractEndDate: row?.contract_end_date ?? null,
  };
}

export function useEnterpriseAccess() {
  const { user } = useAuth();
  return useQuery({
    queryKey: ['my-enterprise-access', user?.id],
    queryFn: fetchEnterpriseAccess,
    enabled: !!user,
    staleTime: 5 * 60 * 1000,
  });
}
